import React, { useEffect } from "react";

// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
// core components
import Header from "components/Headers/MassiveTransferHeader.js";
import {useDispatch} from "react-redux";
import {cambiaruta,opcadmnav} from "../../Slicersreducers";

const MassiveTransfer = (props) => {
    const dispatch=useDispatch();

    useEffect(()=>{
        dispatch(cambiaruta("Inicio/Transacciones Masivas"));
        dispatch(opcadmnav(""));
    },[]);

    return (
        <>
            <Header account={props.location.state} key="header"/>
        </>
    )
}

export default MassiveTransfer;